import React, { FC } from 'react'

import { Timeline } from 'antd'

import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import CardContent from '@mui/material/CardContent'

export const HelpView: FC<{ onClose: () => void }> = ({ onClose }) => {
  // const redirect = useRedirect();

  // const onClickViewWelcomeMessage = (): void => {
  //   onClose();
  //   redirect('?welcome=true');
  // };

  return (
    <div style={{ backgroundColor: '#ebebeb', height: '100%', padding: 30 }}>
      <Card style={{ height: '100%' }}>
        <CardHeader title="Support" />
        <CardContent>
          <div style={{ marginBottom: 45 }}>
            <h3>Read Formtopia Docs</h3>
            <p>
              Explore{' '}
              <a href="https://powcloud.com/formtopia/docs/">
                <strong>Form</strong>topia documentation
              </a>{' '}
              to learn how to build powerful forms more quickly than ever.
            </p>
          </div>
          <div style={{ marginBottom: 45 }}>
            <h3>Interact with the Community</h3>
            <p>Discover what topics other community members are discussing with</p>
            <a href="https://stackoverflow.com/questions/tagged/formtopia">
              <mark>#formtopia</mark> on
              <img src="https://powcloud.com/img/3rdparty/stack-overflow-icon.svg" style={{ height: 24, width: 24 }} />
              <span className="text-muted">Stack Overflow</span>
            </a>
            .
          </div>
          <div style={{ marginBottom: 45 }}>
            <h3>View Our Helpdesk</h3>
            <p>
              You can find many resources and submit support requests at{' '}
              <a href="https://support.powcloud.com">our helpdesk</a>.
            </p>
          </div>
          <p>
            If you have questions about using your account or experience any issues, please contact us via{' '}
            <a href="mailto:help@powcloud.com">help@powcloud.com</a>.
          </p>
        </CardContent>
      </Card>
    </div>
  )
}
